import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import About from './views/about'
import Contact from './views/contact'
import Home from './views/home'
import Terms from './views/terms'
import Approach from './views/approach'
import FAQs from './views/fa-qs'
import Donate from './views/donate'
import Volunteers from './views/volunteers'
import Partners from './views/partners'
import Programs from './views/programs'
import Blog from './views/blog'
import Testimonials from './views/testimonials'
import Privacy from './views/privacy'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={About} exact path="/about" />
        <Route component={Contact} exact path="/contact" />
        <Route component={Home} exact path="/" />
        <Route component={Terms} exact path="/terms" />
        <Route component={Approach} exact path="/approach" />
        <Route component={FAQs} exact path="/fa-qs" />
        <Route component={Donate} exact path="/donate" />
        <Route component={Volunteers} exact path="/volunteers" />
        <Route component={Partners} exact path="/partners" />
        <Route component={Programs} exact path="/programs" />
        <Route component={Blog} exact path="/blog" />
        <Route component={Testimonials} exact path="/testimonials" />
        <Route component={Privacy} exact path="/privacy" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
